
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28698",
  depVersions: {
  "payments-ui-app": "static-1.28698",
  "bend-plugin-arboretum": "static-1.2017",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.510",
  "crm_data": "static-4.93195",
  "data-fetching-client": "static-1.10111",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8744",
  "foundations-components-legacy": "static-1.1769",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6064",
  "hs-test-utils": "static-1.8508",
  "hub-http": "static-1.6679",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11960",
  "I18n": "static-7.1706",
  "jasmine-runner": "static-1.6923",
  "quartz": "static-1.7650",
  "raven": "static-3.5925",
  "react-dlb": "static-1.93",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.120",
  "react-utils": "static-2.5654",
  "reselect": "static-3.16",
  "stripe-js": "static-1.119",
  "ui-components-test-utils": "static-1.6097",
  "UIComponents": "static-3.8906",
  "usage-tracker-public": "static-1.7605",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38046",
  "payments-checkout-lib": "static-1.621",
  "cssUtils": "static-1.1096",
  "customer-data-objects": "static-1.8174",
  "FireAlarmUi": "static-1.4860",
  "foundations-assets": "static-1.5357",
  "foundations-theming": "static-1.4960",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12267",
  "icons": "static-2.702",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3357",
  "property-translator": "static-1.5851",
  "quartz-config": "static-1.1428",
  "quartz-core": "static-1.6869",
  "quartz-i18n": "static-1.1325",
  "quartz-routing": "static-1.1080",
  "quartz-tracking": "static-1.1029",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17205",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10841",
  "rpc-client-utils": "static-1.5143",
  "sanitize-text": "static-1.8630",
  "SharedI18nStrings": "static-1.187",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5230",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11619",
  "ui-images": "static-2.1276",
  "usage-tracker-core": "static-1.7644",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3927",
  "quartz-webpack": "static-1.3874",
  "bend-plugin-quartz-routing": "static-1.728",
  "bender-build-tools": "static-1.3567",
  "crm_universal": "static-1.22720",
  "customer-data-email": "static-1.18634",
  "customer-data-ui-utilities": "static-1.10307",
  "dispatcher": "static-1.147",
  "frontend-preferences-client": "static-1.8392",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8235",
  "quick-fetch": "static-1.4229",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5013",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2676",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9895",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.101",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3072",
  "ui-fonts": "static-1.1222",
  "HeadJS": "static-2.820",
  "hs-test-utils-bend-plugin": "static-1.3619",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.398",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4781",
  "foundations-components-test-utils": "static-1.6227",
  "ui-addon-draggable": "static-3.5221",
  "commerce-billing-lib": "static-1.20483",
  "commerce-shared-components-lib": "static-1.19559",
  "commerce-tools-ui-lib": "static-1.11316",
  "crm-message-bus": "static-1.44093",
  "customer-data-objects-ui-components": "static-1.13506",
  "customer-data-properties": "static-1.53023",
  "growth-payments-core": "static-1.26495",
  "ui-addon-iframeable": "static-1.9546",
  "usage-tracker": "static-1.7794",
  "usage-tracker-container": "static-1.7784",
  "sassPrefix": "static-1.360",
  "inbound-db-properties-service-client": "static-1.4150",
  "foundations-theming-base": "static-1.3945",
  "bend-plugin-foundations-theming": "static-1.3443",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.263",
  "hub-http-janus": "static-1.905",
  "hubspotter-http": "static-1.4973",
  "mobile-manifest-mixins": "static-1.604",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.638",
  "quartz-auth": "static-1.1325",
  "quartz-head": "static-1.1315",
  "quartz-test": "static-1.1325",
  "trellis-components": "static-1.3091",
  "usage-tracker-session-replay": "static-1.5480",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.172",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.553",
  "chirp-fetch": "static-1.2375",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4945",
  "FormUrlGenerator": "static-2.5188",
  "sequences-lib": "static-1.8766",
  "apollo-link-hub-http": "static-2.5060",
  "FileManagerCore": "static-1.40329",
  "FileManagerLib": "static-1.40470",
  "hubspot-apollo-client": "static-1.5352",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.730",
  "timezone-utils": "static-2.5703",
  "ui-gdpr-components": "static-1.10655",
  "react-dnd-compat": "static-1.5083",
  "stylex-utils": "static-1.173",
  "trellis-theming": "static-1.1471",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2959",
  "hs-resources": "static-1.665",
  "pulse": "static-1.1119",
  "utility-belt": "static-1.3009",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2018",
  "customer-data-associations": "static-1.7811",
  "customer-data-property-utils": "static-1.8523",
  "customer-data-tracking": "static-1.7341",
  "framework-data-schema-resolvers": "static-1.7364",
  "framework-data-table": "static-2.12833",
  "object-builder-ui-client": "static-1.50037",
  "payments-enrollment-embed-lib": "static-1.24186",
  "stripe-embedded-components": "static-1.8239",
  "ui-addon-opt": "static-4.8875",
  "ai-components-ui-library": "static-1.10012",
  "customer-data-rte": "static-1.33897",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24830",
  "growth-onboarding-confetti": "static-1.3532",
  "growth-onboarding-empty-states": "static-1.6527",
  "hubspot-prosemirror": "static-1.19273",
  "InboxConnectUtils": "static-4.15838",
  "payment-link-components": "static-1.24449",
  "payments-post-enroll-local-storage-lib": "static-1.5576",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39162",
  "react-colorpicker": "static-2.10682",
  "ui-addon-upgrades": "static-9.18547",
  "ui-addon-video-player": "static-1.9095",
  "user-context": "static-1.5525",
  "restore-request-side-panel-lib": "static-1.2025",
  "atom": "static-1.5544",
  "reference-resolvers": "static-1.8653",
  "calling-global-api": "static-1.66175",
  "calling-internal-common": "static-1.31797",
  "calling-lifecycle-internal": "static-1.67557",
  "calling-lifecycle-messages": "static-1.59850",
  "commerce-products-lib": "static-1.10903",
  "conditional-properties-service-client": "static-1.4111",
  "crm-index-visualization-core": "static-1.4753",
  "crm-links": "static-1.6781",
  "crm-pipelines-api-client-types": "static-1.4441",
  "customer-data-properties-shared-msw-handlers": "static-1.10222",
  "external-options-client-types": "static-1.4438",
  "formula-editor": "static-1.15007",
  "google-libphonenumber": "static-1.49",
  "inbound-db-meta-service-client": "static-1.3773",
  "inbounddb-objects-service-types": "static-1.4518",
  "meetings-icalendar-utils-lib": "static-1.1107",
  "multi-currency-client-types": "static-1.4006",
  "pipeline-validation-client-types": "static-1.4279",
  "property-value-citations": "static-1.3637",
  "reference-resolvers-lite": "static-1.8581",
  "smart-data-capture-core": "static-1.466",
  "smart-property-lib": "static-1.8646",
  "tiered-pricing": "static-1.2260",
  "topics-actions-lib": "static-1.656",
  "trellis-ext-i18n": "static-1.1382",
  "trial-components-library": "static-1.14370",
  "ui-addon-form-validation": "static-1.11347",
  "laboratory-lib": "static-3.7620",
  "onboarding-scopes": "static-1.6924",
  "seat-types-lib": "static-1.1044",
  "magpie-lib": "static-1.5905",
  "navigation-messaging": "static-1.8489",
  "ts-schema": "static-1.4391",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10895",
  "hubspotter-http-shared-msw-handlers": "static-1.10893",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8623",
  "audio-components": "static-1.6564",
  "breeze-artifacts-sdk": "static-1.927",
  "ContentUtils": "static-1.69462",
  "copilot-toolkit": "static-1.12139",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30056",
  "FileManagerImages": "static-1.37981",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4614",
  "ui-universal-auth": "static-1.9733",
  "urlinator": "static-1.4988",
  "video-components": "static-1.14425",
  "video-data-lib": "static-1.36081",
  "video-embed": "static-1.36915",
  "hubspot-apollo-cache": "static-1.811",
  "trellis-migration-context": "static-1.50",
  "event-emitter": "static-1.1435",
  "fdsr-migration-layer": "static-1.483",
  "framework-builder-read-service-client": "static-1.4333",
  "bend-plugin-pulse": "static-1.622",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7269",
  "persist-promise": "static-1.4175",
  "customer-data-reference-ui-components": "static-1.13645",
  "reporting-data": "static-1.69335",
  "tasks-actions-lib": "static-1.426",
  "purchase-motions-components": "static-1.6624",
  "growth-onboarding-feedback-components": "static-1.7055",
  "growth-onboarding-reliability": "static-1.5555",
  "marketplace-ui-apps-core": "static-1.19575",
  "onboarding-tours": "static-1.17398",
  "stripe-connect-js": "static-1.82",
  "chatspot-core": "static-1.23854",
  "content-assistance-lib": "static-1.8417",
  "draft-content-plugins": "static-1.29150",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22353",
  "rich-text-lib": "static-1.20547",
  "breeze-engine-lib": "static-1.2149",
  "poll-commands": "static-1.3949",
  "video-components-external": "static-1.12423",
  "trellis-story-utils": "static-1.4971",
  "ui-addon-react-router-dom": "static-1.10000",
  "content-media-capture": "static-1.5781",
  "knowledge-content-types": "static-1.8760",
  "ui-addon-emoji-picker": "static-1.10334",
  "ui-business-units-lib": "static-1.9569",
  "ui-shepherd-react": "static-3.10750",
  "hub-http-contrib": "static-1.3503",
  "ui-addon-sales-email": "static-1.5675",
  "commerce-tours-lib": "static-1.6858",
  "getting-started-shared-tasks": "static-1.19555",
  "sales-checkout-service-client": "static-1.3995",
  "merchandise-lib": "static-1.284",
  "getting-started-shared-tasks-store": "static-1.18673",
  "onboarding-tours-utils": "static-1.1465",
  "calling-error-reporting": "static-1.31804",
  "shared-worker-versioning": "static-1.11513",
  "calling-usage-tracker": "static-1.7010",
  "conversations-skeleton-state": "static-1.7607",
  "voice-sms-access-library": "static-1.2429",
  "commerce-permissions": "static-1.1258",
  "products-iframe-lib": "static-1.8902",
  "products-ui-components-shared-msw-handlers": "static-1.11277",
  "crm-index-associations-lib": "static-1.6922",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10978",
  "sales-views-client-types": "static-1.4727",
  "location-customization-utils-lib": "static-1.10411",
  "bark-lib": "static-1.17004",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6366",
  "react-codemirror": "static-1.11113",
  "data-agent-kit": "static-1.909",
  "data-agent-test-utils": "static-1.453",
  "data-agent-utils": "static-1.922",
  "data-token-picker": "static-1.17128",
  "fsm": "static-1.4231",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7282",
  "react-tinymce": "static-1.56264",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11041",
  "tinymce-config": "static-2.55390",
  "tinymce-plugins": "static-1.58504",
  "embedded-academy-lib": "static-1.15998",
  "hubs-service-types": "static-1.1738",
  "navigation-components": "static-1.19162",
  "nest": "static-1.707",
  "nudge-client-utils": "static-1.3414",
  "purchase-motions-api": "static-1.6627",
  "signup-constants": "static-1.19935",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5365",
  "reactive-lib": "static-1.1192",
  "simple-logging-lib": "static-1.3524",
  "nav-meta": "static-1.30799",
  "breeze-engine-core": "static-1.1427",
  "cms-field-types": "static-1.5284",
  "content-icons-ui": "static-1.2455",
  "integrations-lib": "static-1.17422",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.297",
  "unified-auth-core-lib": "static-1.1529",
  "social-insights-client-types": "static-1.22922",
  "outpost": "static-1.4601",
  "reporting-client-types": "static-1.2832",
  "signup-ui-url-generator": "static-2.8520",
  "developer-experience-shared-components": "static-1.11010",
  "immutable-less": "static-1.5126",
  "marketplace-ui-client-types": "static-1.18450",
  "marketplace-ui-common": "static-1.21043",
  "ui-addon-integrations-directory-panel": "static-2.8426",
  "ui-extensibility-client-types": "static-1.4389",
  "growth-data-modal": "static-1.6130",
  "growth-onboarding-next-action-utils": "static-1.2976",
  "onboarding-tours-client": "static-1.5613",
  "ui-shepherd-tracker": "static-1.8131",
  "ui-coaching-tips": "static-1.29580",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1127",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13585",
  "content-media-compositions": "static-2.17592",
  "media-bridge-lib": "static-1.19635",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4900",
  "calling-orchestration-schema": "static-1.37206",
  "crm-record-cards-service-types": "static-1.3871",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16662",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "enrichment-settings-lib": "static-1.228",
  "storybook-react": "static-1.44",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57360",
  "interframe": "static-3.5212",
  "tinymce-data": "static-1.41475",
  "layout-dnd-components": "static-1.13222",
  "layout-dnd-utils": "static-1.12197",
  "ui-brand-identity-lib": "static-1.16934",
  "academy-common-lib": "static-1.15459",
  "nudge-custom-function-registry": "static-1.3171",
  "nudge-renderer-utils": "static-1.3490",
  "whisper-core-api": "static-1.7628",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14837",
  "integrations-tracking-lib": "static-1.6091",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4609",
  "ai-settings-ui-library": "static-1.8578",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1570",
  "onboarding-data-sync-lib": "static-1.2836",
  "growth-onboarding-next-action-components": "static-1.3004",
  "user-context-client": "static-1.4983",
  "js-cookie": "static-1.18",
  "NamespacedHubStyle": "static-2.9365",
  "ContentData": "static-1.69537",
  "layout-data-lib": "static-1.10522",
  "academy-service-client": "static-1.4164",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4867",
  "trellis-ecosystem": "static-1.7845",
  "wootric-nps": "static-1.7295",
  "universal-page-editor-lib": "static-1.3482",
  "settings-ui-lib": "static-1.13000",
  "simple-data-table": "static-1.3812",
  "meetings-connect-utils-lib": "static-1.8089",
  "advanced-menus-core": "static-1.15811",
  "advanced-menus-lib": "static-1.12566",
  "ExportDialog": "static-6.10845",
  "ui-memberships-settings-lib": "static-1.35179",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15810",
  "simple-menus-lib": "static-1.17327"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28698",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2017",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.510",
  "crm_data": "/crm_data/static-4.93195",
  "data-fetching-client": "/data-fetching-client/static-1.10111",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8744",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1769",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6064",
  "hs-test-utils": "/hs-test-utils/static-1.8508",
  "hub-http": "/hub-http/static-1.6679",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11960",
  "I18n": "/I18n/static-7.1706",
  "jasmine-runner": "/jasmine-runner/static-1.6923",
  "quartz": "/quartz/static-1.7650",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.120",
  "react-utils": "/react-utils/static-2.5654",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.119",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6097",
  "UIComponents": "/UIComponents/static-3.8906",
  "usage-tracker-public": "/usage-tracker-public/static-1.7605",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38046",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.621",
  "cssUtils": "/cssUtils/static-1.1096",
  "customer-data-objects": "/customer-data-objects/static-1.8174",
  "FireAlarmUi": "/FireAlarmUi/static-1.4860",
  "foundations-assets": "/foundations-assets/static-1.5357",
  "foundations-theming": "/foundations-theming/static-1.4960",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12267",
  "icons": "/icons/static-2.702",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3357",
  "property-translator": "/property-translator/static-1.5851",
  "quartz-config": "/quartz-config/static-1.1428",
  "quartz-core": "/quartz-core/static-1.6869",
  "quartz-i18n": "/quartz-i18n/static-1.1325",
  "quartz-routing": "/quartz-routing/static-1.1080",
  "quartz-tracking": "/quartz-tracking/static-1.1029",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17205",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10841",
  "rpc-client-utils": "/rpc-client-utils/static-1.5143",
  "sanitize-text": "/sanitize-text/static-1.8630",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5230",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11619",
  "ui-images": "/ui-images/static-2.1276",
  "usage-tracker-core": "/usage-tracker-core/static-1.7644",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3927",
  "quartz-webpack": "/quartz-webpack/static-1.3874",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.728",
  "bender-build-tools": "/bender-build-tools/static-1.3567",
  "crm_universal": "/crm_universal/static-1.22720",
  "customer-data-email": "/customer-data-email/static-1.18634",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10307",
  "dispatcher": "/dispatcher/static-1.147",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8392",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8235",
  "quick-fetch": "/quick-fetch/static-1.4229",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5013",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2676",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9895",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3072",
  "ui-fonts": "/ui-fonts/static-1.1222",
  "HeadJS": "/HeadJS/static-2.820",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3619",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.398",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4781",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6227",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5221",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20483",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19559",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11316",
  "crm-message-bus": "/crm-message-bus/static-1.44093",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13506",
  "customer-data-properties": "/customer-data-properties/static-1.53023",
  "growth-payments-core": "/growth-payments-core/static-1.26495",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9546",
  "usage-tracker": "/usage-tracker/static-1.7794",
  "usage-tracker-container": "/usage-tracker-container/static-1.7784",
  "sassPrefix": "/sassPrefix/static-1.360",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4150",
  "foundations-theming-base": "/foundations-theming-base/static-1.3945",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3443",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.263",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hubspotter-http": "/hubspotter-http/static-1.4973",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.604",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.638",
  "quartz-auth": "/quartz-auth/static-1.1325",
  "quartz-head": "/quartz-head/static-1.1315",
  "quartz-test": "/quartz-test/static-1.1325",
  "trellis-components": "/trellis-components/static-1.3091",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5480",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.172",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.553",
  "chirp-fetch": "/chirp-fetch/static-1.2375",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4945",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5188",
  "sequences-lib": "/sequences-lib/static-1.8766",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5060",
  "FileManagerCore": "/FileManagerCore/static-1.40329",
  "FileManagerLib": "/FileManagerLib/static-1.40470",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5352",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.730",
  "timezone-utils": "/timezone-utils/static-2.5703",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10655",
  "react-dnd-compat": "/react-dnd-compat/static-1.5083",
  "stylex-utils": "/stylex-utils/static-1.173",
  "trellis-theming": "/trellis-theming/static-1.1471",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2959",
  "hs-resources": "/hs-resources/static-1.665",
  "pulse": "/pulse/static-1.1119",
  "utility-belt": "/utility-belt/static-1.3009",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2018",
  "customer-data-associations": "/customer-data-associations/static-1.7811",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8523",
  "customer-data-tracking": "/customer-data-tracking/static-1.7341",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7364",
  "framework-data-table": "/framework-data-table/static-2.12833",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50037",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24186",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8239",
  "ui-addon-opt": "/ui-addon-opt/static-4.8875",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10012",
  "customer-data-rte": "/customer-data-rte/static-1.33897",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24830",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3532",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6527",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19273",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15838",
  "payment-link-components": "/payment-link-components/static-1.24449",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5576",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39162",
  "react-colorpicker": "/react-colorpicker/static-2.10682",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9095",
  "user-context": "/user-context/static-1.5525",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2025",
  "atom": "/atom/static-1.5544",
  "reference-resolvers": "/reference-resolvers/static-1.8653",
  "calling-global-api": "/calling-global-api/static-1.66175",
  "calling-internal-common": "/calling-internal-common/static-1.31797",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67557",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59850",
  "commerce-products-lib": "/commerce-products-lib/static-1.10903",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4111",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4753",
  "crm-links": "/crm-links/static-1.6781",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4441",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10222",
  "external-options-client-types": "/external-options-client-types/static-1.4438",
  "formula-editor": "/formula-editor/static-1.15007",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4518",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1107",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4006",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4279",
  "property-value-citations": "/property-value-citations/static-1.3637",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8581",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.466",
  "smart-property-lib": "/smart-property-lib/static-1.8646",
  "tiered-pricing": "/tiered-pricing/static-1.2260",
  "topics-actions-lib": "/topics-actions-lib/static-1.656",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1382",
  "trial-components-library": "/trial-components-library/static-1.14370",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11347",
  "laboratory-lib": "/laboratory-lib/static-3.7620",
  "onboarding-scopes": "/onboarding-scopes/static-1.6924",
  "seat-types-lib": "/seat-types-lib/static-1.1044",
  "magpie-lib": "/magpie-lib/static-1.5905",
  "navigation-messaging": "/navigation-messaging/static-1.8489",
  "ts-schema": "/ts-schema/static-1.4391",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10895",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10893",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8623",
  "audio-components": "/audio-components/static-1.6564",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.927",
  "ContentUtils": "/ContentUtils/static-1.69462",
  "copilot-toolkit": "/copilot-toolkit/static-1.12139",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30056",
  "FileManagerImages": "/FileManagerImages/static-1.37981",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4614",
  "ui-universal-auth": "/ui-universal-auth/static-1.9733",
  "urlinator": "/urlinator/static-1.4988",
  "video-components": "/video-components/static-1.14425",
  "video-data-lib": "/video-data-lib/static-1.36081",
  "video-embed": "/video-embed/static-1.36915",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.811",
  "trellis-migration-context": "/trellis-migration-context/static-1.50",
  "event-emitter": "/event-emitter/static-1.1435",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.483",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4333",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.622",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7269",
  "persist-promise": "/persist-promise/static-1.4175",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13645",
  "reporting-data": "/reporting-data/static-1.69335",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.426",
  "purchase-motions-components": "/purchase-motions-components/static-1.6624",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7055",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5555",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19575",
  "onboarding-tours": "/onboarding-tours/static-1.17398",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "chatspot-core": "/chatspot-core/static-1.23854",
  "content-assistance-lib": "/content-assistance-lib/static-1.8417",
  "draft-content-plugins": "/draft-content-plugins/static-1.29150",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22353",
  "rich-text-lib": "/rich-text-lib/static-1.20547",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2149",
  "poll-commands": "/poll-commands/static-1.3949",
  "video-components-external": "/video-components-external/static-1.12423",
  "trellis-story-utils": "/trellis-story-utils/static-1.4971",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10000",
  "content-media-capture": "/content-media-capture/static-1.5781",
  "knowledge-content-types": "/knowledge-content-types/static-1.8760",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10334",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9569",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10750",
  "hub-http-contrib": "/hub-http-contrib/static-1.3503",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5675",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6858",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19555",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3995",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18673",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1465",
  "calling-error-reporting": "/calling-error-reporting/static-1.31804",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11513",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7010",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2429",
  "commerce-permissions": "/commerce-permissions/static-1.1258",
  "products-iframe-lib": "/products-iframe-lib/static-1.8902",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11277",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6922",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10978",
  "sales-views-client-types": "/sales-views-client-types/static-1.4727",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10411",
  "bark-lib": "/bark-lib/static-1.17004",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6366",
  "react-codemirror": "/react-codemirror/static-1.11113",
  "data-agent-kit": "/data-agent-kit/static-1.909",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.453",
  "data-agent-utils": "/data-agent-utils/static-1.922",
  "data-token-picker": "/data-token-picker/static-1.17128",
  "fsm": "/fsm/static-1.4231",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-tinymce": "/react-tinymce/static-1.56264",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11041",
  "tinymce-config": "/tinymce-config/static-2.55390",
  "tinymce-plugins": "/tinymce-plugins/static-1.58504",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15998",
  "hubs-service-types": "/hubs-service-types/static-1.1738",
  "navigation-components": "/navigation-components/static-1.19162",
  "nest": "/nest/static-1.707",
  "nudge-client-utils": "/nudge-client-utils/static-1.3414",
  "purchase-motions-api": "/purchase-motions-api/static-1.6627",
  "signup-constants": "/signup-constants/static-1.19935",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5365",
  "reactive-lib": "/reactive-lib/static-1.1192",
  "simple-logging-lib": "/simple-logging-lib/static-1.3524",
  "nav-meta": "/nav-meta/static-1.30799",
  "breeze-engine-core": "/breeze-engine-core/static-1.1427",
  "cms-field-types": "/cms-field-types/static-1.5284",
  "content-icons-ui": "/content-icons-ui/static-1.2455",
  "integrations-lib": "/integrations-lib/static-1.17422",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.297",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1529",
  "social-insights-client-types": "/social-insights-client-types/static-1.22922",
  "outpost": "/outpost/static-1.4601",
  "reporting-client-types": "/reporting-client-types/static-1.2832",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11010",
  "immutable-less": "/immutable-less/static-1.5126",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18450",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21043",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8426",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4389",
  "growth-data-modal": "/growth-data-modal/static-1.6130",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2976",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5613",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8131",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29580",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1127",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13585",
  "content-media-compositions": "/content-media-compositions/static-2.17592",
  "media-bridge-lib": "/media-bridge-lib/static-1.19635",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4900",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37206",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16662",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.228",
  "storybook-react": "/storybook-react/static-1.44",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57360",
  "interframe": "/interframe/static-3.5212",
  "tinymce-data": "/tinymce-data/static-1.41475",
  "layout-dnd-components": "/layout-dnd-components/static-1.13222",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12197",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16934",
  "academy-common-lib": "/academy-common-lib/static-1.15459",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3171",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3490",
  "whisper-core-api": "/whisper-core-api/static-1.7628",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14837",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6091",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4609",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8578",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1570",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2836",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3004",
  "user-context-client": "/user-context-client/static-1.4983",
  "js-cookie": "/js-cookie/static-1.18",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "ContentData": "/ContentData/static-1.69537",
  "layout-data-lib": "/layout-data-lib/static-1.10522",
  "academy-service-client": "/academy-service-client/static-1.4164",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4867",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7845",
  "wootric-nps": "/wootric-nps/static-1.7295",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3482",
  "settings-ui-lib": "/settings-ui-lib/static-1.13000",
  "simple-data-table": "/simple-data-table/static-1.3812",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8089",
  "advanced-menus-core": "/advanced-menus-core/static-1.15811",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12566",
  "ExportDialog": "/ExportDialog/static-6.10845",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35179",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15810",
  "simple-menus-lib": "/simple-menus-lib/static-1.17327"
}
};
